import { PERSON_GROUP_MEMBER  } from "actions/types";
import { baseStore } from "../common/baseStore"

export default baseStore(PERSON_GROUP_MEMBER)
